import * as React from 'react';
import { ITranslatedComponent } from '../../redux/reducers/generalReducer';
import {AssignedModeltypeBasicDto} from '../../services/Client';
import {translate} from 'react-i18next';
import {Card} from 'semantic-ui-react';
import {DerivateUtils} from "../../components/Table/components/derivate/DerivateUtils";

interface IModeltypesLineProps extends ITranslatedComponent {
    assignedModeltypes?: AssignedModeltypeBasicDto[] | undefined;
    previousAssignedModeltypes?: AssignedModeltypeBasicDto[] | undefined;
    fluid?: boolean;
    userLanguage: string;
}

const ModeltypesLine: React.StatelessComponent<IModeltypesLineProps> = (props) => {
    const {t, assignedModeltypes, fluid, previousAssignedModeltypes} = props;

    const renderAssignments = () => {
        let deletedDerivtes: any[] = [];
        let addedDerivtes: any[] = [];

        if (previousAssignedModeltypes && assignedModeltypes) {
            deletedDerivtes = previousAssignedModeltypes.filter(x => !assignedModeltypes.map(y => y.objectId).includes(x.objectId)); // deleted derivates
            addedDerivtes = assignedModeltypes.filter(x => !previousAssignedModeltypes.map(y => y.objectId).includes(x.objectId)); // added derivates
        }
        // @ts-ignore already checked in render
        let newDerivates = assignedModeltypes.map( amtb => {
            const derivateName = DerivateUtils.renderDerivateName(amtb.modeltypeBasic, props.userLanguage);
            return (amtb.modeltypeBasic && derivateName &&
                (
                    <div key={amtb.objectId} style={{fontWeight: addedDerivtes.includes(amtb) ? 'bold' : 'normal'}}>
                        {derivateName} - {t("ASSIGNMENT_TYPE_" + amtb.assignmentType)}
                    </div>
                )
            );
        });

        let deleted = deletedDerivtes.map( amtb => {
            return (amtb.modeltypeBasic && amtb.modeltypeBasic.name &&
                (
                    <div key={amtb.objectId} style={{textDecoration: 'line-through'}}>
                        {amtb.modeltypeBasic.name} - {t("ASSIGNMENT_TYPE_" + amtb.assignmentType)}
                    </div>
                )
            );
        });

        return newDerivates.concat(deleted);
    };

    return (
        <Card fluid={fluid}>
            <Card.Content>
                <Card.Meta>{t("MODELTYPES")}</Card.Meta>
                {assignedModeltypes && assignedModeltypes.length > 0 ?
                    <Card.Description>{renderAssignments()}</Card.Description>
                    :
                    <Card.Description>{t("NO_MODELTYPE_ASSIGNMENTS")}</Card.Description>
                }
            </Card.Content>
        </Card>
    );
};

export default translate(["APPROVAL_VIEW"])(ModeltypesLine);



// WEBPACK FOOTER //
// ./src/views/ApprovalView/ModeltypesLine.tsx